import { render } from "./ServiceHeader.vue?vue&type=template&id=3ca2ab2e"
import script from "./ServiceHeader.vue?vue&type=script&lang=js"
export * from "./ServiceHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__